import api from "../../services/api";
import {
  GET_COUNTRIES_FAILURE,
  GET_COUNTRIES_REQUEST,
  GET_COUNTRIES_SUCCESS,
} from "./ActionType";

const getCountriesRequest = () => {
  return {
    type: GET_COUNTRIES_REQUEST,
  };
};

const getCountriesSuccess = (payload) => {
  return {
    type: GET_COUNTRIES_SUCCESS,
    payload,
  };
};

const getCountriesFailure = (payload) => {
  return {
    type: GET_COUNTRIES_FAILURE,
    payload,
  };
};

export const getCountries = () => async (dispatch) => {
  dispatch(getCountriesRequest());
  try {
    const response = await api.get("/countries");
    dispatch(getCountriesSuccess(response.data));
  } catch (error) {
    dispatch(getCountriesFailure(error.message));
  }
};
